<script>
  import { ToastNotification } from "carbon-components-svelte";
  export let title = "";
  export let subtitle = "";
  export let kind = "info";
  export let timeout = 3000;

  let open = true;
</script>

{#if open}
  <div class="toast-container">
    <ToastNotification {title} {subtitle} {kind} lowContrast />
  </div>
{/if}

<style>
  .toast-container {
    position: fixed;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    max-width: 90%;
  }
</style>
